import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Initialize state from localStorage if available
const initializeAuth = () => {
    try {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');

        if (token && userStr) {
            const user = JSON.parse(userStr);
            return {
                user,
                token,
                isAuthenticated: true,
            };
        }
    } catch (error) {
        console.error('Error initializing auth from localStorage:', error);
    }

    return {
        user: null,
        token: null,
        isAuthenticated: false,
    };
};

export const useAuthStore = create(
    persist(
        (set) => ({
            ...initializeAuth(), // Initialize from localStorage

            setAuth: (user, token) => {
                // Ensure synchronous localStorage write
                try {
                    localStorage.setItem('token', token);
                    localStorage.setItem('user', JSON.stringify(user));

                    // Update state after localStorage is confirmed
                    set({ user, token, isAuthenticated: true });
                } catch (error) {
                    console.error('Failed to save auth to localStorage:', error);
                    throw error;
                }
            },

            logout: () => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                set({ user: null, token: null, isAuthenticated: false });
            },

            updateUser: (user) => {
                localStorage.setItem('user', JSON.stringify(user));
                set({ user });
            },
        }),
        {
            name: 'auth-storage',
            // Force synchronous storage for better mobile compatibility
            getStorage: () => localStorage,
        }
    )
);
